module.exports = __webpack_public_path__ + "media/images/athletes/1-b1c7708f6d859a0d6790d1199e5baba1.png";